<template>
    <rkm-layout-body title="Lista de origem programática">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name:'cadastro-origem-programatica-create'})"
                authorize="store-cadastro-origem-programatica"
                color="primary"
            >
                Cadastrar origem programática
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/origem-programatica/List'

export default {
    components: {List},
}
</script>